import { render, staticRenderFns } from "./MobileHeader.vue?vue&type=template&id=011c6a3a&"
import script from "./MobileHeader.vue?vue&type=script&lang=js&"
export * from "./MobileHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('011c6a3a')) {
      api.createRecord('011c6a3a', component.options)
    } else {
      api.reload('011c6a3a', component.options)
    }
    module.hot.accept("./MobileHeader.vue?vue&type=template&id=011c6a3a&", function () {
      api.rerender('011c6a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/MobileHeader.vue"
export default component.exports